import React from 'react';
import './styles.scss';

const Loader = () => {
  return (
    <div className="spinner-wrapper">
      <div className="spinner-border text-primary" role="status" />
      <div>Ładuję...</div>
    </div>
  );
};

export default Loader;
